import { create } from "zustand";

type Notification = {
  msg: string;
  imageUrl?: string;
  duration: number;
  channel?: string;
};

type NotificationStore = {
  notifications: Notification[];
  rewardNotification?: Notification;
  addNotification: (message: string, imageUrl?: string, duration?: number, channel?: string) => void;
  addNotificationNoSpam: (message: string, imageUrl?: string, duration?: number, channel?: string) => void;
  clearNotifications: (channel?: string) => void;
  addRewardNotification: (message: string, duration?: number) => void;
  removeFirst: () => void;
  clearRewardNotification: () => void;
};

export const useNotificationStore = create<NotificationStore>((set) => ({
  notifications: [],
  addNotification: (message: string, imageUrl?: string, duration = 2.5, channel?: string) =>
    set((state) => ({
      notifications: [...state.notifications, { msg: message, imageUrl, duration, channel }],
    })),
  addNotificationNoSpam: (message: string, imageUrl?: string, duration = 2.5, channel?: string) =>
    set((state) => {
      let hasExistingNotification = false;

      if (channel) {
        // If channel is provided, check for duplicates by channel
        hasExistingNotification = state.notifications.some((notification) => notification.channel === channel);
      } else {
        // If no channel is provided, check for duplicates by message content
        hasExistingNotification = state.notifications.some((notification) => notification.msg === message);
      }

      // Only add if no duplicate exists
      if (!hasExistingNotification) {
        return {
          notifications: [...state.notifications, { msg: message, imageUrl, duration, channel }],
        };
      }

      // Return unchanged state if duplicate exists
      return state;
    }),
  clearNotifications: (channel?: string) =>
    set((state) => ({ notifications: state.notifications.filter((x) => x.channel !== channel) })),
  addRewardNotification: (message: string, duration = 8) =>
    set((state) => ({
      ...state,
      rewardNotification: { msg: message, duration },
    })),
  removeFirst: () => set((state) => ({ notifications: state.notifications.slice(1) })),
  clearRewardNotification: () => set((state) => ({ ...state, rewardNotification: undefined })),
}));
